module.exports = __webpack_public_path__ + "img/trash-cart__icon.f139874.svg";